import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import search from '@/libs/search';

import { getAreaList } from '@/api/modules/system-management/area-management';
import { getCustomerManagerUserList } from '@/api/modules/account-management/customerManager-user-management';
import { webGetAllRegion } from '@/api/modules/system-management/region-management';

export const getExternalCustomerUserList = data => {
    return axios.request({
        url: 'api/accountManagement/externalCustomerUserManagement/getExternalCustomerUserList',
        data: data,
        method: 'post'
    });
};

export const getCustomerSearchList = data => {
    return axios.request({
        url: 'api/accountManagement/externalCustomerUserManagement/getCustomerSearchList',
        data: data,
        method: 'post'
    });
};

export const getUserReviewsList = data => {
    return axios.request({
        url: 'api/user/getUserReviews',
        data: data,
        method: 'post'
    });
};

export const deleteEreviews = data => {
    return axios.request({
        url: 'api/user/deleteUserReviews',
        data: data,
        method: 'post'
    });
};

export const saveEreviews = data => {
    return axios.request({
        url: 'api/user/saveUserReviews',
        data: data,
        method: 'post'
    });
};

export const getExternalCustomerUserDetail = userExternalCustomerLoginUuid => {
    return axios.request({
        url: 'api/accountManagement/externalCustomerUserManagement/getExternalCustomerUserDetail',
        data: { userExternalCustomerLoginUuid },
        method: 'post'
    });
};

export const pageInit4UserExternalCustomerEdit = () => {
    const areaSearch = search.getSearchParams({ closeAllConditions: true });
    const customerManagerSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getAreaList(areaSearch),
        getCustomerManagerUserList(customerManagerSearch),
        webGetAllRegion()
    ]).then(axiosRequest.spread(function (area, customerManager, region) {
        if (area.code === 0 && customerManager.code === 0 && region.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    area: area.data,
                    customerManager: customerManager.data,
                    region: region.data
                }
            };
        }
    }));
};

export const externalCustomerUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/externalCustomerUserManagement/externalCustomerUserSave',
        data: data,
        method: 'post'
    });
};
